export const EXEC_CHAT_ACTIONS = [
    {
        name: 'New user set up',
        text: 'Invite a new employee into the system.',
        enum: 'onboarding',
    },
    {
        name: 'User offboarding',
        text: 'Remove access and deactivate an employee account.',
        enum: 'offboarding',
    },
] as const;

export type ExecChatAction = (typeof EXEC_CHAT_ACTIONS)[number];

export type ExecChatActionEnum = ExecChatAction['enum'];
